module.exports = __webpack_public_path__ + "static/media/centro_medio_2.787d4f7e.mp4";